import { GetContextByStateKeyResponse } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { SITE_CONTEXT_CACHE_KEY } from './iwQueryClient';

export function useSiteContext() {
    const { data } = useQuery({
        queryKey: [SITE_CONTEXT_CACHE_KEY]
    });

    return data as GetContextByStateKeyResponse;
}
